import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, message, Pagination, Alert, Button, Select, DatePicker, Dropdown, Menu } from 'antd';
import ReporteService from '../../../services/api/reportes';
import UserService from '../../../services/api/users';
import helper from '../../../utils/helper';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import apiConfig from '../../../services/api/config';
import ImprimirModal from '../../../components/ImprimirModal/ImprimirModal';
const { Option } = Select;

class IndexReportePagos extends Component {
  state = {
    cargando: false,
    reportes: [],
    tipo_servicio_id: '',
    tipo_servicio_formato: 'Todos',
    de: moment().format('YYYY-MM-DD'),
    fecha_fin_temp: moment(),
    a: moment().format('YYYY-MM-DD'),
    fecha_inicio_temp: moment(),
    openImprimirModal: false,
    nombre_vendedor: '',
    page: {
      number: 1,
      per_page: 15,
      order_column: 'created_at',
      order_type: 'desc',
      from: 0,
      to: 0,
      last_page: 0,
      total: 0,
      buscar_texto: '',
    },
  };

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(this.handleChangeLocation);
    if (this.props.location && this.props.location.search) {
      const queryString = new URLSearchParams(this.props.location.search);
      if (queryString) {
        const buscar_texto = queryString.get('buscar_texto');
        const configPage = Object.assign({}, this.state.page);
        configPage.buscar_texto = buscar_texto;
        this.setState({
          page: configPage,
        });
      }
    }

    this.cargarUsers();

    this.setState({
      nombre_vendedor: this.props.user && this.props.user.name ?  this.props.user.name: ''
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  cargarUsers = (path = undefined) => {
    this.setState({
      cargando_user: true,
    });

    path = `?page=1&per_page=50&order_column=created_at&order_type=desc`;

    UserService.getUsers(
      path,
      (page) => {
        if (page && page.data && page.data.length > 0) {
          this.setState({
            cargando_user: false,
            users: page.data,
          });
        } else {
          this.setState({
            users: [],
            cargando_user: false,
          });
        }
      },
      (error, result) => {
        if (error) {
          message.error(error.message);
          this.setState({
            cargando_user: false,
          });
        }
      }
    );
  };

  handleChangeSearch = (value) => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = value.target.value;
    this.setState({
      page: configPage,
      buscar_texto: value.target.value
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  handleChangeSearchIcon = () => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = this.state.buscar_texto;
    this.setState({
      page: configPage,
      buscar_texto: this.state.buscar_texto
    }, () => {
      this.cargarPagosPendientes();
    });
  }


  cargarPagosPendientes = (path = undefined) => {
    this.setState({
      cargando: true,
    });

    if (!path || path === undefined) {
      path = `?page=${this.state.page.number}&per_page=${this.state.page.per_page}&order_column=${this.state.page.order_column}&order_type=${this.state.page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&nombre_vendedor=${this.state.nombre_vendedor}`;
      if (this.state.page && this.state.page.buscar_texto && this.state.page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.page.buscar_texto}`;
      }
    }

    ReporteService.getReportes(
      path,
      (page) => {
        if (page && page.data && page.data.length > 0) {
          const configPage = Object.assign({}, this.state.page);
          configPage.from = page.from;
          configPage.to = page.to;
          configPage.last_page = page.last_page;
          configPage.total = page.total;
          configPage.number = page.current_page;
          configPage.per_page = parseInt(page.per_page);
          configPage.buscar_texto = page.buscar_texto ? page.buscar_texto : '';

          this.setState({
            cargando: false,
            reportes: page.data,
            page: configPage,
          });
        } else {
          this.setState({
            reportes: [],
            cargando: false,
          });
        }
      },
      (error, result) => {
        if (error) {
          message.error(error.message);
          this.setState({
            cargando: false,
          });
        }
      }
    );
  };

  handleChangeLocation = (location, action) => {
    const queryString = new URLSearchParams(location.search);
    const buscar_texto = queryString.get('buscar_texto');

    if (buscar_texto && buscar_texto != null) {
      const page = Object.assign({}, this.state.page);

      page.buscar_texto = buscar_texto;

      this.setState({
        page,
      });

      setTimeout(() => {
        this.cargarPagosPendientes();
      }, 10);
    }
  };

  handleChangePerPage = (current, pageSize) => {
    const page = Object.assign({}, this.state.page);
    page.number = current;
    page.per_page = pageSize;
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&nombre_vendedor=${this.state.nombre_vendedor}`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    this.props.history.push(path);
    this.cargarPagosPendientes(path);
  };

  showTotal = (total) => {
    return `Total ${total} registros`;
  };

  handleClickExportarPDF = (tipo) => {
    if (tipo === 'xls') {
      const page = Object.assign({}, this.state.page);
      let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
      if (this.state.buscar_texto !== undefined || this.state.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.buscar_texto}`;
      }
      const token =  null;
      const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/informe-ingresos-percibidos${path}&authorization=${token}&empresa_id=${apiConfig.constants.EMPRESA_ID}&nombre_vendedor=${this.state.nombre_vendedor}`;
      window.open(url_exportar);
    } else {
      const page = Object.assign({}, this.state.page);
      let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
      if (this.state.buscar_texto !== undefined || this.state.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.buscar_texto}`;
      }
      const token =  null;
      const url_exportar = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/cuota-ordinaria/pdf${path}&authorization=${token}&empresa_id=${apiConfig.constants.EMPRESA_ID}&nombre_vendedor=${this.state.nombre_vendedor}`;
      window.open(url_exportar);
    }
  };

  handleChangeTipo = (value, opt) => {
    this.setState({
      tipo_servicio_id: value,
      tipo_servicio_formato: opt.label
    }, () => {
      this.cargarPagosPendientes();
    });
  };

  onChangeInicio = (value) => {
    this.setState({
      de: value.format('YYYY-MM-DD'),
      fecha_inicio_temp: value
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  onChangeFin = (value) => {
    this.setState({
      a: value.format('YYYY-MM-DD'),
      fecha_fin_temp: value
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  handleExportar = (value, tipo = '') => {
    if (tipo === 'xls') {
      const page = Object.assign({}, this.state.page);
      const empresa_id =apiConfig.constants.EMPRESA_ID;
      const token = null;
      let printPDFUrl = null;

      if (value === '1') {
        printPDFUrl = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/informe-ingresos-percibidos-forma-pago?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}&nombre_vendedor=${this.state.nombre_vendedor}`;
      } else if (value === '2') {
        printPDFUrl = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/informe-ingresos-percibidos-detalle?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}&nombre_vendedor=${this.state.nombre_vendedor}`;
      } else {
        printPDFUrl = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/informe-ingresos-percibidos-caja?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}&nombre_vendedor=${this.state.nombre_vendedor}`;
      }
      if (this.state.buscar_texto !== undefined || this.state.buscar_texto !== '') {
        printPDFUrl = `${printPDFUrl}&buscar_texto=${this.state.buscar_texto}`;
      }

      window.open(printPDFUrl);
      this.setState({
        printPDFUrl
      })
    } else {
      const page = Object.assign({}, this.state.page);
      const empresa_id =apiConfig.constants.EMPRESA_ID;
      const token = null;
      let printPDFUrl = null;

      if (value === '1') {
        printPDFUrl = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/forma-pago?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}&nombre_vendedor=${this.state.nombre_vendedor}`;
      } else if (value === '2') {
        printPDFUrl = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/tipo-servicios?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}&nombre_vendedor=${this.state.nombre_vendedor}`;
      } else {
        printPDFUrl = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/tipo-servicios-caja?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}&nombre_vendedor=${this.state.nombre_vendedor}`;
      }
      if (this.state.buscar_texto !== undefined || this.state.buscar_texto !== '') {
        printPDFUrl = `${printPDFUrl}&buscar_texto=${this.state.buscar_texto}`;
      }

      this.setState({
        printPDFUrl,
        openImprimirModal: true
      })
    }
  }

  handleClickCloseImprimirModal = (value) => {
    this.setState({
      openImprimirModal: false
    })
  }

  onChangeVendedor = (value) => {
    this.setState({ nombre_vendedor: value }, () => {
      this.cargarPagosPendientes();
    });
  };

  render() {
    const reportes = this.state.reportes;

    const columns = [
      {
        title: 'N°',
        dataIndex: 'name',
        key: 'name',
        responsive: ['xl'],
        width: 50,
        render: (text, record, index) => {
          return <div>{index + 1}</div>;
        },
      },
      {
        title: 'Comprobante',
        dataIndex: 'serie_formato',
        key: 'serie_formato',
        responsive: ['lg', 'xl'],
      },
      {
        title: 'Cliente',
        dataIndex: 'cuenta_formato',
        responsive: ['lg', 'xl'],
        ellipsis: true,
      },      
      {
        title: 'Fecha',
        dataIndex: 'fecha_cobranza',
        key: 'fecha_cobranza',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'S/. Importe',
        dataIndex: 'importe_cobrado',
        key: 'importe_cobrado',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        render: (text, record) => (
          <div>
           {record.es_anticipo && parseFloat(record.saldo_pendiente_anticipo) === 0 ? '-': ''} {text}
          </div>
        ),
      },
      {
        title: 'Doc. Identidad',
        dataIndex: 'documento_identidad',
        key: 'documento_identidad',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
    ];

    const menu = (
      <Menu>
        {
          <Menu.Item key="1" onClick={() => this.handleExportar('1')}>
            Reporte Resumen Agrupado por Forma de Pago
          </Menu.Item>
        }
        {
          <Menu.Item key="2" onClick={() => this.handleExportar('2')}>
            Informe Ingresos Percibidos - Detallado
          </Menu.Item>
        }
        {
          <Menu.Item key="3" onClick={() => this.handleExportar('3')}>
            Reporte de ingresos detallado por Caja
          </Menu.Item>
        }
        {
          <Menu.Item key="4" onClick={() => this.handleExportar('1', 'xls')}>
            Reporte Resumen Agrupado por Forma de Pago (XLS)
          </Menu.Item>
        }
        {
          <Menu.Item key="5" onClick={() => this.handleExportar('2', 'xls')}>
            Informe Ingresos Percibidos - Detallado (XLS)
          </Menu.Item>
        }
        {
          <Menu.Item key="6" onClick={() => this.handleExportar('3', 'xls')}>
            Reporte de ingresos detallado por Caja (XLS)
          </Menu.Item>
        }
      </Menu>
    );

    return (
      <div>
        <div className="page-header">
          <h2 className="page-header">Informe Ingresos Percibidos - Detallado</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 6 }}>
            <div className="topnav__search">
              <input
                type="text"
                placeholder="Buscar..."
                onChange={this.handleChangeSearch}
                value={ this.state.buscar_texto }
              />
              <i onClick={() => this.handleChangeSearchIcon()} className="bx bx-search" style={{cursor: 'pointer'}}></i>
            </div>
            {
              helper.tienePermiso(this.props.permisos, 'ver reportes de otros usuarios') &&
              <div>
              <Select
                showSearch
                placeholder="Seleccione"
                onChange={this.onChangeVendedor}
                value={this.state.nombre_vendedor}
                style={{ width: 100 }}
              >
                <Option key="Todos" value="">
                Todos
                </Option>
                {this.state.users &&
                  this.state.users.length > 0 &&
                  this.state.users.map((item, index) => {
                    return (
                      <Option key={index} value={item.name}>
                        {item.name}
                      </Option>
                    );
                  })}
              </Select>
              </div>
            }
            <div>
              <Select
              value={this.state.tipo_servicio_id}
                onChange={this.handleChangeTipo}
                style={{ width: 200 }}
                options={[
                  {
                    value: '',
                    label: 'Todos',
                  },
                  {
                    value: 'CuotaOrdinaria',
                    label: 'Cuota Ordinaria',
                  },
                  {
                    value: 'Capacitaciones',
                    label: 'Capacitaciones',
                  },
                  {
                    value: 'HabilitacionDeColegiatura',
                    label: 'Habilitación de Colegiatura',
                  },
                  {
                    value: 'FondoMutual',
                    label: 'Fondo Mutual',
                  },
                  {
                    value: 'FondoMutualDeFallecido',
                    label: 'Fondo Mutual de Fallecido',
                  },
                  {
                    value: 'AdelantoFondoMutual',
                    label: 'Adelanto Fondo Mututal',
                  },
                  {
                    value: 'Fraccionamiento',
                    label: 'Fraccionamiento',
                  },
                  {
                    value: 'Productos',
                    label: 'Productos',
                  },
                ]}
              />
            </div>
            <div>
            <DatePicker style={{ width: 120 }} value={this.state.fecha_inicio_temp} onChange={this.onChangeInicio} />
            </div>
            <div>
            <DatePicker style={{ width: 120 }} value={this.state.fecha_fin_temp} onChange={this.onChangeFin} />
            </div>
            <div>
              <Button onClick={() => this.handleClickExportarPDF('')} type="primary" shape="round" icon={<DownloadOutlined />} size={null}>
                PDF
              </Button>
            </div>
            <div>
              <Button onClick={() => this.handleClickExportarPDF('xls')} type="primary" shape="round" icon={<DownloadOutlined />} size={null}>
                XLS
              </Button>
            </div>
            <div>
            <Dropdown overlay={menu} placement="bottomRight">
              <Button>Otros Reportes</Button>
            </Dropdown>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {!helper.tienePermiso(this.props.permisos, 'Ver registro pagos pendientes') ? (
                <Alert
                  message="Permiso"
                  description="No tiene permiso para ver lista de pagos pendientes"
                  type="error"
                />):
                <div className="card__body">

                  <Table
                    rowKey={(record, index) => index}
                    columns={columns}                    dataSource={reportes}
                    pagination={false}
                    loading={this.state.cargando}
                    size="small"
                  />
                  <div style={{ paddingTop: 12, textAlign: 'right' }}>
                    <Pagination
                      size="small"
                      showTotal={this.showTotal}
                      total={this.state.page.total}
                      current={this.state.page.number}
                      pageSize={this.state.page.per_page}
                      onChange={this.handleChangePerPage}
                      onShowSizeChange={this.handleChangePerPage}
                      pageSizeOptions={[10, 20, 30, 40]}
                      showQuickJumper
                      showSizeChanger
                    />
                  </div>
                </div>
              }              
            </div>
          </div>
        </div>
        {this.state.openImprimirModal ? (
          <ImprimirModal
            visible={this.state.openImprimirModal}
            onCancel={this.handleClickCloseImprimirModal}
            url={this.state.printPDFUrl}
            mime_type="application/pdf"
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisos: state && state.user && state.user.permisos.length > 0 ? state.user.permisos : [],
    user: state && state.user ? state.user: null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexReportePagos);
